/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * 
 * @export
 * @interface GraduatedPrice
 */
export interface GraduatedPrice {
    /**
     * 
     * @type {number}
     * @memberof GraduatedPrice
     */
    amount: number;
    /**
     * 
     * @type {Price}
     * @memberof GraduatedPrice
     */
    price: Price;
}

/**
 * Check if a given object implements the GraduatedPrice interface.
 */
export function instanceOfGraduatedPrice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "price" in value;

    return isInstance;
}

export function GraduatedPriceFromJSON(json: any): GraduatedPrice {
    return GraduatedPriceFromJSONTyped(json, false);
}

export function GraduatedPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GraduatedPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'price': PriceFromJSON(json['price']),
    };
}

export function GraduatedPriceToJSON(value?: GraduatedPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'price': PriceToJSON(value.price),
    };
}

